(() => {
    function updateFacetsPosition() {
        const announcementWrapper = document.querySelector('.announcement-wrapper');
        const isAnnouncementHidden = document.querySelector('.announcement-wrapper.announcement-wrapper--hidden');
        const facetsWrapper = document.querySelector('.facets-wrapper');
        
        if (facetsWrapper) {
            facetsWrapper.style.position = 'sticky';
            
            if (isAnnouncementHidden || !announcementWrapper) {
                facetsWrapper.style.top = 'var(--header-offset-announcement-filter)';
            } else {
                facetsWrapper.style.top = 'var(--header-offset-filter)';
            }
        }
    }
    
    updateFacetsPosition();
    
    window.addEventListener('scroll', function() {
        const facetsWrapper = document.querySelector('.facets-wrapper');
        if (!facetsWrapper) return;
        
        updateFacetsPosition();
    });
    
    window.addEventListener('resize', function() {
        updateFacetsPosition();
        const facetsWrapper = document.querySelector('.facets-wrapper');

        if (facetsWrapper && facetsWrapper.style.position === 'fixed') {
            facetsWrapper.style.width = `${facetsWrapper.parentElement.getBoundingClientRect().width}px`;
        }
    });
})();